export default "assets/images/icons/next-a6009219.svg";